import {
  SALES_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  SALES_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  SALES_MASSIVE_UPLOAD_REQUEST_VERIFY,
  SALES_MASSIVE_UPLOAD_SET_VERIFY,
  SALES_MASSIVE_UPLOAD_CLEAR_VERIFY,
  SALES_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  SALES_MASSIVE_UPLOAD_SET_UPLOAD,
  SALES_MASSIVE_UPLOAD_CLEAR_UPLOAD,
} from '../actions';

function SalesMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case SALES_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case SALES_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case SALES_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case SALES_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case SALES_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case SALES_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case SALES_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case SALES_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    default:
      return state;
  }
}

export default SalesMassiveUploadReducer;
